import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ElevatorDetail from './pages/ElevatorDetail';
import AdminPanel from './pages/AdminPanel';
import './App.css';

/**
 * 主应用组件 - 使用React Router实现URL路由
 * 
 * 路由结构：
 * / - 用户端首页（电梯列表和搜索）
 * /elevator/:id - 独立电梯详情页（支持二维码扫描）
 * /admin - 管理员控制台（电梯管理 + 字段管理）
 */
function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/elevator/:id" element={<ElevatorDetail />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </Router>
  );
}

export default App;
